import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { withUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface RefreshExclamationIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const ThemedSvg = withUnistyles(Svg);

const RefreshExclamationIcon = ({
  size = 20,
  color = 'iconPrimary',
  ...props
}: RefreshExclamationIconProps) => (
  <ThemedSvg
    width={size * (22 / 20)}
    height={size}
    viewBox="0 0 22 20"
    fill="none"
    uniProps={(t) => ({ color: t[color] })}
    {...props}
  >
    <Path
      d="M0.700481 8.10784C-0.00851858 8.10784 -0.185768 8.58824 0.198273 9.13726L2.40405 12.2549C2.72901 12.7059 3.20167 12.6961 3.51678 12.2549L5.72256 9.12745C6.09675 8.58824 5.9195 8.10784 5.22035 8.10784H3.79251C4.64921 4.40196 7.95788 1.67647 11.9558 1.67647C16.6037 1.67647 20.326 5.37255 20.326 10C20.326 14.6275 16.6037 18.3529 11.9558 18.3333C9.14939 18.3235 6.68758 16.9706 5.18096 14.8824C4.8757 14.4804 4.41288 14.3529 3.9993 14.598C3.60541 14.8431 3.49709 15.3824 3.83189 15.8137C5.70286 18.3137 8.63733 20 11.9558 20C17.4407 20 22 15.4608 22 10C22 4.52941 17.4407 0 11.9558 0C7.11102 0 2.99488 3.51961 2.08894 8.10784H0.700481ZM11.946 11.7647C12.4187 11.7647 12.6944 11.5 12.7042 10.9902L12.8421 5.81373C12.8519 5.31373 12.4581 4.94118 11.9361 4.94118C11.4044 4.94118 11.0302 5.30392 11.0401 5.80392L11.1779 10.9902C11.1878 11.4902 11.4536 11.7647 11.946 11.7647ZM11.946 14.951C12.5171 14.951 13.0095 14.5 13.0095 13.9314C13.0095 13.3627 12.527 12.9118 11.946 12.9118C11.365 12.9118 10.8825 13.3725 10.8825 13.9314C10.8825 14.4902 11.3749 14.951 11.946 14.951Z"
      fill="currentColor"
    />
  </ThemedSvg>
);

RefreshExclamationIcon.displayName = 'RefreshExclamationIcon';
export { RefreshExclamationIcon };
